/**
 * AgentSurface — an Omni Ad cowork view rendered as a normal platform page.
 *
 * The cowork module ships its own left sidebar; inside the Beatly shell that
 * job belongs to AppSidebar, so we mount it in `embedded` mode and drive the
 * view from the URL (see AGENT_PAGE_VIEW in routes.ts).
 */
import { AlertCircle } from 'lucide-react';
import { isCoworkLive } from '@/cowork/live/coworkClient';
import { CoworkPage } from '@/cowork/omniad/components/CoworkPage';

export function AgentSurface({ view }: { view: string }) {
  if (!isCoworkLive()) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
        <AlertCircle className="h-8 w-8 text-gray-300" aria-hidden />
        <p className="text-sm text-gray-600">
          Agents aren&apos;t connected in this environment.
        </p>
        <p className="max-w-sm text-xs text-gray-400">
          Set <code className="rounded bg-gray-100 px-1 py-0.5">VITE_COWORK_API_URL</code> to
          point this app at the Omni Ad backend.
        </p>
      </div>
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <CoworkPage embedded initialView={view as any} />;
}
